import React, { useEffect } from 'react';
import { SalesHero } from '../components/SalesHero';
import { SalesContent } from '../components/SalesContent';
import { SalesOffer } from '../components/SalesOffer';
import { Footer } from '../components/Footer';
import { initMetaPixel } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-cream-100 text-ink-900 font-sans selection:bg-slate-teal/20 selection:text-ink-900" data-id="element-212">
      <SalesHero data-id="element-213" />
      <SalesContent data-id="element-214" />
      <SalesOffer data-id="element-215" />
      <Footer data-id="element-216" />
    </main>;
}